import React, { Component } from "react";
import Paper from "@mui/material/Paper";
import {
  Divider,
  TextField,
  CardHeader,
  CardContent,
  InputAdornment,
} from "@mui/material";
import Card from "@mui/material/Card";
import "./css/InverterSelectorForm.css";

export class CapacityView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      numlightfix: this.props.numFixture,
      wattperlightfix: this.props.wattTotal,
      totalcap: this.props.mytotalcap,
      allowanceTotal: this.props.allowTotal,
      sumofPowerRating: this.props.totalcap,
      showCapEdit: false,
      showNextButton:
        this.props.wattTotal === "" || this.props.numFixture === ""
          ? false
          : true,
    };
  }

  getSumofPowerRating(totalallow, totcap) {
    const sum = parseInt(totalallow) + parseInt(totcap);

    this.setState({ sumofPowerRating: sum.toString() }, () => {
      //Set the power rating
      this.props.powerRatingFilteredData(this.state.sumofPowerRating);
      //console.log("Save power rating")
    });

    //this.setState({ showNextButton: true });
    this.props.showNextButton(true);
  }

  getTotalAllowance(totalcapResult) {
    const totalwAllowance = parseInt(totalcapResult) * 0.2;

    this.setState({ allowanceTotal: totalwAllowance.toString() }, () => {
      this.props.saveAllowanceTotal(this.state.allowanceTotal);
    });

    this.getSumofPowerRating(totalwAllowance, totalcapResult);
  }

  callcap(nlight, wattlight) {
    if (nlight !== "" && wattlight !== "") {
      const totalcapResult = parseInt(nlight) * parseInt(wattlight);

      this.setState({ totalcap: totalcapResult.toString() }, () => {
        this.props.saveMyTotalCap(this.state.totalcap);
      });

      this.getTotalAllowance(totalcapResult);
    }
  }

  handleNumLightTextFieldChange = (event) => {
    if (event.target.value < 0) {
      event.target.value = 0;
    }

    this.setState({ numlightfix: event.target.value }, () => {
      this.props.saveNumFixture(this.state.numlightfix);
    });
    this.callcap(event.target.value, this.state.wattperlightfix);
  };
  handleWattlightfixTextFieldChange = (event) => {
    if (event.target.value < 0) {
      event.target.value = 0;
    }

    this.setState({ wattperlightfix: event.target.value }, () => {
      //Call func to save wattperlightfix data
      this.props.saveWattTotal(this.state.wattperlightfix);
    });
    this.callcap(this.state.numlightfix, event.target.value);
  };

  confirmPowerRatingFunction = (event) => {
    //Call func to filter power rating data
    this.setState({ showNextButton: true });
    this.props.showNextButton(true);
    this.props.showPrevButton(false);
  };

  render() {
    const {
      numlightfix,
      wattperlightfix,
      totalcap,
      allowanceTotal,
      sumofPowerRating,
    } = this.state;

    return (
      <Paper elevation={10}>
        <Card>
          <CardHeader
            titleTypographyProps={{
              fontFamily: "Ford-Normal",
            }}
            fontFamily="Ford-SemiBold"
            className="paperh-title"
            title="Calculate Your UL924 Inverter Capacity for EM Lighting"
            subheader="To determine your total capacity requirements, Please fill in the information below"
          ></CardHeader>
          <CardContent className="cc-cardcontent">
            <TextField
              InputLabelProps={{ style: { fontFamily: "Ford-Normal" } }} // font size of input label
              type="number"
              sx={{
                m: 0.98,
                width: "100%",
                maxWidth: "560px",
                "& input": { textAlign: "end" , fontFamily: 'Ford-Normal'},
              }}
              id="outlined-search"
              label="How many lighting fixtures do you have?"
              value={numlightfix}
              onChange={this.handleNumLightTextFieldChange}
              variant="filled"
            ></TextField>
            <TextField
              InputLabelProps={{ style: { fontFamily: "Ford-Normal" } }} // font size of input label
              type="number"
              sx={{
                m: 1,
                width: "100%",
                maxWidth: "560px",
                "& input": { textAlign: "end" , fontFamily: 'Ford-Normal'},
              }}
              id="outlined-search"
              label="What is the wattage per fixture?"
              value={wattperlightfix}
              onChange={this.handleWattlightfixTextFieldChange}
              variant="filled"
            ></TextField>
            {/* C */}
            <TextField
              InputLabelProps={{ style: { fontFamily: "Ford-Normal" } }} // font size of input label
              sx={{
                m: 1,
                width: "100%",
                maxWidth: "560px",
                "& input": { textAlign: "end" , fontFamily: 'Ford-Normal'},
              }}
              id="outlined-search"
              label="Your lighting fixture capacity is?"
              value={totalcap}
              variant="filled"
              onChange={(event) =>
                this.setState({ totalcap: event.target.value })
              }
              helperText="Note: To determine your final capacity requirements it is required to add a minimum of 20% tolerance of your lighting fixture capacity requirements."
            ></TextField>
            <Divider />{" "}
            <TextField
 
              InputLabelProps={{ style: { fontFamily: "Ford-Normal" } }} // font size of input label
              label="The minimum tolerance for your lighting fixture capacity is:"
              variant="outlined"
              helperText="Potential additional load of 20%"
              sx={{
                m: 1,
                width: "60%",
                "& input": { textAlign: "end" , fontFamily: 'Ford-Normal'},
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {allowanceTotal >= 10000 ? "kW" : "W"}
                  </InputAdornment>
                ),
              }}
              value={
                (allowanceTotal >= 10000
                  ? allowanceTotal / 1000
                  : allowanceTotal) || 0
              }
            />
            <TextField

              InputLabelProps={{ style: { fontFamily: "Ford-Normal" } }} // font size of input label
              label="Recommended Capacity:"
              variant="outlined"
              
              sx={{
                m: 1,
                width: "60%",
                "& input": { textAlign: "end" , fontFamily: 'Ford-Normal'},
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment  position="end">
                    {sumofPowerRating >= 10000 ? "kW" : "W"}
                  </InputAdornment>
                ),
              }}
              value={
                "Total Inverter Size of " +
                  (sumofPowerRating >= 10000
                    ? sumofPowerRating / 1000
                    : sumofPowerRating) || 0
              }
            />
          </CardContent>
        </Card>
      </Paper>
    );
  }
}
